export default "__VITE_ASSET__BxM3Uygh__"